<template>
    <div>
        <Header></Header>
        <referee-form></referee-form>
        <referee-table></referee-table>
    </div>
</template>

<script>
import RefereeForm from '@/components/dashboard/referee/RefereeForm'
import Header from '@/components/dashboard/Header'
import RefereeTable from '@/components/dashboard/referee/RefereeTable'

export default {
    data() {
        return {
            
        }
    },
    components : {
        Header,
        RefereeForm,
        RefereeTable
    }
}
</script>
